import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { config } from "../../App";
import axios from "axios";


const QuickActions = () => {

  const token = sessionStorage.getItem("token");
  const empId = sessionStorage.getItem("EmployeeID");

  const quickActions = [
    { title: "SOD Booking", icon: "/images/icon/sod-icon.svg", url: "https://sod.spicejet.com/", className: "sod", external: true, isExternal: "_blank" },
    { title: "ELT Booking", icon: "/images/icon/elt-icon.svg", url: "https://elt.spicejet.com/", className: "elt", external: true, isExternal: "_blank" },
    { title: "IT Computation", icon: "/images/icon/it-computation-icon.svg", url: `/itComputation`, className: "it-computation", external: false, isExternal: "" },
    { title: "Reimbursement Slip", icon: "/images/icon/reimbursement-slip-icon.svg", url: `/reimbursementSlip`, className: "reimbursement", external: false, isExternal: "" },

    { title: "Spice Star", icon: "/images/icon/spiceStar-icon.svg", requiresApi: true, appName: "spicestar" },
    { title: "SAP Password", icon: "/images/icon/sap-icon.svg", requiresApi: true, appName: "sap_pass" },
    { title: "E-Sarahana", icon: "/images/icon/e-sarahana-icon.svg", requiresApi: true, appName: "e-sarahana" },

    { title: "Co-mail / Co-mat", icon: "/images/icon/co-mail-icon.svg", url: "https://comail.spicejet.com/", className: "co-mail", external: true, isExternal: "_blank" },
    { title: "Zoho", icon: "/images/icon/zoho-icon.svg", url: "https://people.zoho.com/spicejet/zp", className: "zoho", external: true, isExternal: "_blank" },
    { title: "Appraisal Letter", icon: "/images/icon/appraisal.svg", url: `/appraisalLetter`, className: "appraisal-letter", external: false, isExternal: "" }
  ];

  const onClickHendler = async (val) => {
    const payload = {
      Username: empId,
      AppName: val
    }

    try {
      const response = await axios.post(
        `${config.endpoint}/auth/Applogin`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.Status) {
        const { Url, Token } = response.data;
        const ssoUrl = `${Url}?u=${empId}&t=${Token}&app=${val}`;

        // console.log("ssoUrl", ssoUrl);

        window.open(ssoUrl, "_blank");
      } else {
        console.error("API returned false status", response.data);
      }
    } catch (err) {
      console.error("API error:", err);
    }
  }

  return (
    <div className="quickAction mt-4 mb-5">
      <h2>Quick Actions</h2>

      <ul>
        {quickActions.map((item, index) => (
          <li key={index} className="mb-4">

            {item.requiresApi ? (
              <div
                onClick={() => onClickHendler(item.appName)}
                className="quick-card d-flex justify-content-center align-items-center text-center"
                style={{ cursor: "pointer" }}
              >
                <div>
                  <img src={item.icon} alt={item.title} />
                  <p>{item.title}</p>
                </div>
              </div>

            ) : item.external ? (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="quick-card d-flex justify-content-center align-items-center text-center"
              >
                <div>
                  <img src={item.icon} alt={item.title} className={item.className} />
                  <p>{item.title}</p>
                </div>
              </a>

            ) : (
              <Link
                to={item.url}
                className="quick-card d-flex justify-content-center align-items-center text-center"
              >
                <div>
                  <img src={item.icon} alt={item.title} />
                  <p>{item.title}</p>
                </div>
              </Link>
            )}

          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickActions;